import { defineComponent as O, onMounted as me, computed as Q, openBlock as f, createBlock as A, resolveDynamicComponent as je, normalizeClass as N, withCtx as W, createElementBlock as v, renderSlot as C, createElementVNode as m, unref as T, normalizeStyle as J, useSlots as xe, ref as E, watch as Y, onUnmounted as Se, withModifiers as H, createTextVNode as re, toDisplayString as ee, createVNode as G, Fragment as Ye, renderList as Qe, createCommentVNode as I, mergeProps as Ce, withKeys as fe, nextTick as et, toRef as Ue, Transition as ze, pushScopeId as _e, popScopeId as Me, onBeforeUpdate as tt, onBeforeUnmount as nt, mergeModels as Ne, useModel as it } from "vue";
const ot = {
  key: 0,
  class: "loading-spinner animate-spin"
}, at = /* @__PURE__ */ O({
  __name: "VButton",
  props: {
    component: {
      type: [Object, String],
      default: "button"
    },
    variant: {
      required: !1,
      type: String,
      default: "light"
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    isLoading: {
      type: Boolean,
      default: !1
    },
    type: {
      type: String,
      default: "button"
    },
    rounded: {
      type: [Boolean, String],
      default: !1
    },
    noShadow: {
      type: [Boolean, String],
      default: !1
    },
    fontWeight: {
      type: String,
      default: "normal"
    },
    to: {
      type: [String, Object],
      default: null
    },
    href: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: "xl"
    },
    analyticsEventName: {
      type: String,
      default: null
    },
    location: {
      type: String,
      default: null
    }
  },
  emits: ["click", "buttonMounted"],
  setup(t, { emit: g }) {
    const s = t, d = g;
    me(() => {
      s.analyticsEventName && d("buttonMounted");
    });
    function n() {
      !s.disabled && !s.isLoading && d("click");
    }
    const i = Q(() => s.size.split(" ").map((l) => (l.includes(":") && (l = `${l.split(":")[1]}-bp-${l.split(":")[0]}`), `size-${l}`)).join(" "));
    return (l, u) => (f(), A(je(t.component), {
      class: N(["border border-black outline-none cursor-pointer v-button transition-all duration-300 shadow-sm", [
        `v-btn-${t.variant}`,
        `font-${t.fontWeight}`,
        `${i.value}`,
        t.rounded ? "rounded-full" : "rounded-md",
        { "no-shadow": t.noShadow, loading: t.isLoading, disabled: t.disabled || t.isLoading }
      ]]),
      to: t.to,
      href: t.to ? void 0 : t.href,
      disabled: t.disabled || t.isLoading,
      inert: t.disabled || t.isLoading,
      type: t.component === "button" ? t.type : null,
      onClick: n
    }, {
      default: W(() => [
        t.isLoading ? (f(), v("div", ot)) : C(l.$slots, "default", { key: 1 }, void 0, !0)
      ]),
      _: 3
    }, 8, ["to", "href", "disabled", "inert", "type", "class"]));
  }
});
const j = (t, g) => {
  const s = t.__vccOpts || t;
  for (const [d, n] of g)
    s[d] = n;
  return s;
}, De = /* @__PURE__ */ j(at, [["__scopeId", "data-v-829f33aa"]]);
function Fe(t, g) {
  return f(), v("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    })
  ]);
}
function Ge(t, g) {
  return f(), v("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m4.5 12.75 6 6 9-13.5"
    })
  ]);
}
function qe(t, g) {
  return f(), v("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m19.5 8.25-7.5 7.5-7.5-7.5"
    })
  ]);
}
function rt(t, g) {
  return f(), v("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m4.5 15.75 7.5-7.5 7.5 7.5"
    })
  ]);
}
function Re(t, g) {
  return f(), v("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
    })
  ]);
}
function lt(t, g) {
  return f(), v("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
    })
  ]);
}
function st(t, g) {
  return f(), v("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    })
  ]);
}
function He(t, g) {
  return f(), v("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "fill-rule": "evenodd",
      d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function ut(t, g) {
  return f(), v("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "fill-rule": "evenodd",
      d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function dt(t, g) {
  return f(), v("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", { d: "M3.53 2.47a.75.75 0 0 0-1.06 1.06l18 18a.75.75 0 1 0 1.06-1.06l-18-18ZM22.676 12.553a11.249 11.249 0 0 1-2.631 4.31l-3.099-3.099a5.25 5.25 0 0 0-6.71-6.71L7.759 4.577a11.217 11.217 0 0 1 4.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113Z" }),
    m("path", { d: "M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0 1 15.75 12ZM12.53 15.713l-4.243-4.244a3.75 3.75 0 0 0 4.244 4.243Z" }),
    m("path", { d: "M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 0 0-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 0 1 6.75 12Z" })
  ]);
}
function ct(t, g) {
  return f(), v("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", { d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" }),
    m("path", {
      "fill-rule": "evenodd",
      d: "M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 0 1 0-1.113ZM17.25 12a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function ft(t, g) {
  return f(), v("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "fill-rule": "evenodd",
      d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function mt(t, g) {
  return f(), v("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "fill-rule": "evenodd",
      d: "M5.25 12a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function ke(t, g) {
  return f(), v("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "fill-rule": "evenodd",
      d: "M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
const gt = ["id", "name", "checked", "disabled"], pt = /* @__PURE__ */ O({
  __name: "VCheckbox",
  props: {
    id: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    modelValue: {
      type: Boolean,
      default: null
    },
    partial: {
      type: Boolean,
      default: !1
    },
    variant: {
      type: String,
      default: "primary"
    },
    color: {
      type: String,
      default: null
    },
    error: {
      type: Boolean,
      default: !1
    },
    background: {
      type: String,
      default: "transparent"
    },
    disabled: {
      type: [Boolean, String],
      default: !1
    }
  },
  emits: ["update:modelValue"],
  setup(t) {
    return (g, s) => (f(), v("div", {
      class: N(["relative h-4 w-4 text-white mb-0 flex-none", { "opacity-70": t.disabled }])
    }, [
      m("input", {
        id: t.id,
        class: N(["box-content absolute top-0 left-0 w-full h-full appearance-none border border-gray-300", [`focus_ring-copper-900 focus_ring ${t.variant} bg-${t.background}`, { error: t.error, "cursor-pointer": !t.disabled }]]),
        type: "checkbox",
        name: t.name,
        checked: t.modelValue,
        disabled: t.disabled,
        onInput: s[0] || (s[0] = (d) => g.$emit("update:modelValue", d.target.checked))
      }, null, 42, gt),
      t.partial ? (f(), A(T(mt), {
        key: 0,
        class: "check-icon pointer-events-none absolute top-0 left-0 w-full h-full rounded hidden",
        style: J(t.color && { background: t.color })
      }, null, 8, ["style"])) : (f(), A(T(Ge), {
        key: 1,
        class: "check-icon pointer-events-none absolute top-0 left-0 w-full h-full rounded hidden",
        style: J(t.color && { background: t.color })
      }, null, 8, ["style"]))
    ], 2));
  }
});
const In = /* @__PURE__ */ j(pt, [["__scopeId", "data-v-f762be7a"]]), vt = ["disabled"], wt = {
  key: 3,
  class: "truncate text-gray-400"
}, ht = {
  class: "overflow-y-auto option-scrollable",
  "data-testid": "dropdown-container"
}, bt = ["onClick"], yt = /* @__PURE__ */ O({
  __name: "VDropdown",
  props: {
    options: {},
    modelValue: {},
    placeholder: { default: "No selection" },
    disabled: { type: Boolean, default: !1 },
    size: { default: "md" },
    theme: { default: "light" },
    containerClasses: { default: "" },
    isDropdownOpen: { type: Boolean, default: !1 },
    multi: { type: Boolean, default: !1 }
  },
  emits: ["toggle", "update:modelValue"],
  setup(t, { emit: g }) {
    function s(e, a) {
      return !e || !a ? !1 : 0 < (e.compareDocumentPosition(a) & Node.DOCUMENT_POSITION_CONTAINS);
    }
    const d = t, n = g, i = xe(), l = E(!1), u = E(), h = Q(() => i.default);
    Y(
      () => d.isDropdownOpen,
      (e) => l.value = e
    ), me(() => document.addEventListener("click", _)), Se(() => document.removeEventListener("click", _));
    function p(e) {
      if (d.multi) {
        const a = Array.isArray(d.modelValue) ? d.modelValue : [], o = a.findIndex(({ id: r }) => r === e.id);
        o === -1 ? a.push(e) : a.splice(o, 1), n("update:modelValue", a);
      } else
        l.value = !1, n("update:modelValue", e);
    }
    function P() {
      l.value = !l.value && !d.disabled, n("toggle", l.value);
    }
    function _(e) {
      s(e.target, u.value) || (l.value = !1, n("toggle", !1));
    }
    return (e, a) => (f(), v("div", {
      ref_key: "domNode",
      ref: u,
      class: N(["relative flex items-center w-full p-0 transition border border-gray-600 rounded-md shadow-sm appearance-none cursor-pointer select-box duration-400 hover_border-gray-400", [{ active: l.value }, `size-${e.size}`, `select-box--${e.theme}`]])
    }, [
      m("button", {
        disabled: e.disabled,
        class: "flex items-center justify-between w-full h-full text-left bg-transparent collapsed",
        "data-testid": "selector-selected-item",
        onClick: H(P, ["prevent"])
      }, [
        e.multi && (e.modelValue === null || !e.modelValue.length) ? C(e.$slots, "default", {
          key: 0,
          class: "truncate text-gray-400"
        }, () => [
          re(ee(e.placeholder), 1)
        ], !0) : e.multi && Array.isArray(e.modelValue) ? C(e.$slots, "current-multi", {
          key: 1,
          items: e.modelValue
        }, void 0, !0) : !e.multi && e.modelValue ? C(e.$slots, "current-single", {
          key: 2,
          item: e.modelValue
        }, void 0, !0) : (f(), v("div", wt, ee(e.placeholder), 1)),
        C(e.$slots, "icon", {}, () => [
          G(T(qe), { class: "flex-shrink-0 text-gray-600 transition duration-200 icon" })
        ], !0)
      ], 8, vt),
      m("div", {
        class: N(["absolute z-10 order-1 text-current bg-white border border-gray-600 rounded-md shadow-sm options-container top-full", [e.containerClasses || "w-full mt-1 right-0"]])
      }, [
        C(e.$slots, "search", {}, void 0, !0),
        m("div", ht, [
          h.value ? C(e.$slots, "default", { key: 0 }, void 0, !0) : (f(!0), v(Ye, { key: 1 }, Qe(e.options, (o) => (f(), v("button", {
            key: o.id,
            class: "option",
            onClick: H((r) => p(o), ["prevent"])
          }, [
            e.multi ? C(e.$slots, "option", {
              key: 0,
              item: o,
              selected: Array.isArray(e.modelValue) && e.modelValue.some(({ id: r }) => r === o.id)
            }, void 0, !0) : C(e.$slots, "option", {
              key: 1,
              item: o,
              selected: !!(e.modelValue && o.id === e.modelValue.id)
            }, void 0, !0)
          ], 8, bt))), 128))
        ])
      ], 2)
    ], 2));
  }
});
const An = /* @__PURE__ */ j(yt, [["__scopeId", "data-v-2ee8e771"]]), kt = { class: "flex items-center justify-between h-10 px-3 py-2 transition-color duration-150" }, xt = /* @__PURE__ */ O({
  __name: "VDropdownItem",
  props: {
    item: {
      type: String,
      required: !0
    },
    selected: {
      type: Boolean,
      default: !1
    },
    variant: {
      type: String,
      default: "copper"
    }
  },
  setup(t) {
    return (g, s) => (f(), v("div", kt, [
      m("span", null, ee(t.item), 1),
      t.selected ? (f(), v("span", {
        key: 0,
        class: N(t.variant)
      }, [
        G(T(Ge), { class: "w-6" })
      ], 2)) : I("", !0)
    ]));
  }
});
const Nn = /* @__PURE__ */ j(xt, [["__scopeId", "data-v-e2f39614"]]), St = /* @__PURE__ */ O({
  __name: "VInput",
  props: {
    type: {
      type: String,
      default: "text"
    },
    size: {
      type: String,
      default: "sm"
    },
    name: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    modelValue: {
      type: [String, Number],
      default: null
    },
    error: {
      type: Boolean,
      default: !1
    },
    rows: {
      type: [String, Number],
      default: null
    },
    maxlength: {
      type: [Number, String],
      default: 500
    },
    readonly: {
      type: [Boolean, String],
      default: !1
    },
    disabled: {
      type: [Boolean, String],
      default: !1
    },
    theme: {
      type: String,
      default: "light"
    },
    step: {
      type: [String, Number],
      default: null
    }
  },
  emits: ["blur", "change", "update:modelValue", "enter"],
  setup(t) {
    const g = t, s = E(!1), d = E(g.type);
    function n() {
      const u = d.value === "password";
      s.value = u, d.value = u ? "text" : "password";
    }
    const i = Q(() => g.disabled || g.readonly), l = Q(() => g.type === "textarea" ? "textarea" : "input");
    return Y(
      () => g.type,
      (u) => {
        d.value = u;
      }
    ), (u, h) => (f(), v("label", {
      class: N(["v-input flex items-center sm_text-sm focus-within_ring-2", [{ "v-input_error": t.error, "v-input_disabled": i.value }, `v-input_theme-${t.theme}`]]),
      "data-testid": "v-input-wrapper"
    }, [
      C(u.$slots, "icon", { error: t.error }, void 0, !0),
      (f(), A(je(l.value), {
        type: d.value,
        name: t.name,
        placeholder: t.placeholder,
        ".value": t.modelValue,
        class: "v-input-main-component w-full placeholder-gray-500 border-none outline-none bg-transparent py-2 px-3 rounded-md",
        rows: t.rows,
        step: t.step,
        maxlength: t.maxlength,
        disabled: t.disabled,
        readonly: t.readonly,
        onChange: h[0] || (h[0] = (p) => u.$emit("change", p)),
        onBlur: h[1] || (h[1] = (p) => u.$emit("blur", p)),
        onInput: h[2] || (h[2] = (p) => u.$emit("update:modelValue", p.target.value)),
        onKeyup: h[3] || (h[3] = (p) => p.key === "Enter" && u.$emit("enter", p.target.value))
      }, null, 40, ["type", "name", "placeholder", ".value", "rows", "step", "maxlength", "disabled", "readonly"])),
      d.value === "password" ? (f(), v("button", {
        key: 0,
        class: "appearance-none p-0 mr-1 bg-transparent text-gray-900",
        type: "button",
        "data-testid": "show-password",
        onClick: n
      }, [
        G(T(ct), { class: "w-6 h-4" })
      ])) : s.value ? (f(), v("button", {
        key: 1,
        type: "button",
        "data-testid": "hide-password",
        class: "appearance-none p-0 mr-1 bg-transparent text-gray-900",
        onClick: n
      }, [
        G(T(dt), { class: "w-6 h-4" })
      ])) : t.error && t.type !== "textarea" ? (f(), A(T(He), {
        key: 2,
        class: "w-6 h-4 select-none text-red-800 mr-1",
        "data-testid": "error-icon"
      })) : I("", !0),
      C(u.$slots, "button", {}, void 0, !0)
    ], 2));
  }
});
const Ct = /* @__PURE__ */ j(St, [["__scopeId", "data-v-78346002"]]), _t = { class: "flex justify-between items-center gap-2" }, Mt = ["name", "min", "max", "step", "value"], $t = { class: "flex-shrink-0 text-sm" }, Bt = /* @__PURE__ */ O({
  __name: "VRangeSlider",
  props: {
    modelValue: {},
    min: {},
    max: {},
    step: {},
    name: {},
    valueFormatter: { type: Function }
  },
  emits: ["update:modelValue"],
  setup(t) {
    const g = t, s = Q(() => {
      const d = parseFloat(`${g.min}`), n = g.modelValue - d, i = parseFloat(`${g.max}`) - d;
      return n / i * 100;
    });
    return (d, n) => (f(), v("div", _t, [
      m("input", {
        name: d.name,
        type: "range",
        min: d.min,
        max: d.max,
        step: d.step,
        value: d.modelValue,
        style: J({
          background: `linear-gradient(to right, #74A9B2 ${s.value}%, #ccc ${s.value}%)`
        }),
        onInput: n[0] || (n[0] = (i) => d.$emit("update:modelValue", parseFloat(i.target.value)))
      }, null, 44, Mt),
      m("span", $t, ee(d.valueFormatter ? d.valueFormatter(d.modelValue) : d.modelValue), 1)
    ]));
  }
});
const Dn = /* @__PURE__ */ j(Bt, [["__scopeId", "data-v-de08fb8c"]]);
var ne = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, We = { exports: {} };
(function(t, g) {
  (function(s, d) {
    t.exports = d();
  })(ne, function() {
    return function(s) {
      var d = {};
      function n(i) {
        if (d[i])
          return d[i].exports;
        var l = d[i] = { i, l: !1, exports: {} };
        return s[i].call(l.exports, l, l.exports, n), l.l = !0, l.exports;
      }
      return n.m = s, n.c = d, n.d = function(i, l, u) {
        n.o(i, l) || Object.defineProperty(i, l, { enumerable: !0, get: u });
      }, n.r = function(i) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(i, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(i, "__esModule", { value: !0 });
      }, n.t = function(i, l) {
        if (1 & l && (i = n(i)), 8 & l || 4 & l && typeof i == "object" && i && i.__esModule)
          return i;
        var u = /* @__PURE__ */ Object.create(null);
        if (n.r(u), Object.defineProperty(u, "default", { enumerable: !0, value: i }), 2 & l && typeof i != "string")
          for (var h in i)
            n.d(u, h, (function(p) {
              return i[p];
            }).bind(null, h));
        return u;
      }, n.n = function(i) {
        var l = i && i.__esModule ? function() {
          return i.default;
        } : function() {
          return i;
        };
        return n.d(l, "a", l), l;
      }, n.o = function(i, l) {
        return Object.prototype.hasOwnProperty.call(i, l);
      }, n.p = "", n(n.s = 0);
    }([function(s, d, n) {
      var i, l, u = n(1)(), h = n(3), p = n(4), P = n(6), _ = function() {
        var e = new p();
        return i = e.getResult(), l = new P(), this;
      };
      _.prototype = { getSoftwareVersion: function() {
        return "0.1.11";
      }, getBrowserData: function() {
        return i;
      }, getFingerprint: function() {
        var e = "|", a = i.ua, o = this.getScreenPrint(), r = this.getPlugins(), c = this.getFonts(), V = this.isLocalStorage(), z = this.isSessionStorage(), k = this.getTimeZone(), b = this.getLanguage(), D = this.getSystemLanguage(), Z = this.isCookie(), y = this.getCanvasPrint();
        return h(a + e + o + e + r + e + c + e + V + e + z + e + k + e + b + e + D + e + Z + e + y, 256);
      }, getCustomFingerprint: function() {
        for (var e = "|", a = "", o = 0; o < arguments.length; o++)
          a += arguments[o] + e;
        return h(a, 256);
      }, getUserAgent: function() {
        return i.ua;
      }, getUserAgentLowerCase: function() {
        return i.ua.toLowerCase();
      }, getBrowser: function() {
        return i.browser.name;
      }, getBrowserVersion: function() {
        return i.browser.version;
      }, getBrowserMajorVersion: function() {
        return i.browser.major;
      }, isIE: function() {
        return /IE/i.test(i.browser.name);
      }, isChrome: function() {
        return /Chrome/i.test(i.browser.name);
      }, isFirefox: function() {
        return /Firefox/i.test(i.browser.name);
      }, isSafari: function() {
        return /Safari/i.test(i.browser.name);
      }, isMobileSafari: function() {
        return /Mobile\sSafari/i.test(i.browser.name);
      }, isOpera: function() {
        return /Opera/i.test(i.browser.name);
      }, getEngine: function() {
        return i.engine.name;
      }, getEngineVersion: function() {
        return i.engine.version;
      }, getOS: function() {
        return i.os.name;
      }, getOSVersion: function() {
        return i.os.version;
      }, isWindows: function() {
        return /Windows/i.test(i.os.name);
      }, isMac: function() {
        return /Mac/i.test(i.os.name);
      }, isLinux: function() {
        return /Linux/i.test(i.os.name);
      }, isUbuntu: function() {
        return /Ubuntu/i.test(i.os.name);
      }, isSolaris: function() {
        return /Solaris/i.test(i.os.name);
      }, getDevice: function() {
        return i.device.model;
      }, getDeviceType: function() {
        return i.device.type;
      }, getDeviceVendor: function() {
        return i.device.vendor;
      }, getCPU: function() {
        return i.cpu.architecture;
      }, isMobile: function() {
        var e = i.ua || navigator.vendor || window.opera;
        return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(e.substr(0, 4));
      }, isMobileMajor: function() {
        return this.isMobileAndroid() || this.isMobileBlackBerry() || this.isMobileIOS() || this.isMobileOpera() || this.isMobileWindows();
      }, isMobileAndroid: function() {
        return !!i.ua.match(/Android/i);
      }, isMobileOpera: function() {
        return !!i.ua.match(/Opera Mini/i);
      }, isMobileWindows: function() {
        return !!i.ua.match(/IEMobile/i);
      }, isMobileBlackBerry: function() {
        return !!i.ua.match(/BlackBerry/i);
      }, isMobileIOS: function() {
        return !!i.ua.match(/iPhone|iPad|iPod/i);
      }, isIphone: function() {
        return !!i.ua.match(/iPhone/i);
      }, isIpad: function() {
        return !!i.ua.match(/iPad/i);
      }, isIpod: function() {
        return !!i.ua.match(/iPod/i);
      }, getScreenPrint: function() {
        return "Current Resolution: " + this.getCurrentResolution() + ", Available Resolution: " + this.getAvailableResolution() + ", Color Depth: " + this.getColorDepth() + ", Device XDPI: " + this.getDeviceXDPI() + ", Device YDPI: " + this.getDeviceYDPI();
      }, getColorDepth: function() {
        return screen.colorDepth;
      }, getCurrentResolution: function() {
        return screen.width + "x" + screen.height;
      }, getAvailableResolution: function() {
        return screen.availWidth + "x" + screen.availHeight;
      }, getDeviceXDPI: function() {
        return screen.deviceXDPI;
      }, getDeviceYDPI: function() {
        return screen.deviceYDPI;
      }, getPlugins: function() {
        for (var e = "", a = 0; a < navigator.plugins.length; a++)
          a == navigator.plugins.length - 1 ? e += navigator.plugins[a].name : e += navigator.plugins[a].name + ", ";
        return e;
      }, isJava: function() {
        return navigator.javaEnabled();
      }, getJavaVersion: function() {
        throw new Error("Please use client.java.js or client.js if you need this functionality!");
      }, isFlash: function() {
        return !!navigator.plugins["Shockwave Flash"];
      }, getFlashVersion: function() {
        throw new Error("Please use client.flash.js or client.js if you need this functionality!");
      }, isSilverlight: function() {
        return !!navigator.plugins["Silverlight Plug-In"];
      }, getSilverlightVersion: function() {
        return this.isSilverlight() ? navigator.plugins["Silverlight Plug-In"].description : "";
      }, isMimeTypes: function() {
        return !(!navigator.mimeTypes || !navigator.mimeTypes.length);
      }, getMimeTypes: function() {
        var e = "";
        if (navigator.mimeTypes)
          for (var a = 0; a < navigator.mimeTypes.length; a++)
            a == navigator.mimeTypes.length - 1 ? e += navigator.mimeTypes[a].description : e += navigator.mimeTypes[a].description + ", ";
        return e;
      }, isFont: function(e) {
        return l.detect(e);
      }, getFonts: function() {
        for (var e = ["Abadi MT Condensed Light", "Adobe Fangsong Std", "Adobe Hebrew", "Adobe Ming Std", "Agency FB", "Aharoni", "Andalus", "Angsana New", "AngsanaUPC", "Aparajita", "Arab", "Arabic Transparent", "Arabic Typesetting", "Arial Baltic", "Arial Black", "Arial CE", "Arial CYR", "Arial Greek", "Arial TUR", "Arial", "Batang", "BatangChe", "Bauhaus 93", "Bell MT", "Bitstream Vera Serif", "Bodoni MT", "Bookman Old Style", "Braggadocio", "Broadway", "Browallia New", "BrowalliaUPC", "Calibri Light", "Calibri", "Californian FB", "Cambria Math", "Cambria", "Candara", "Castellar", "Casual", "Centaur", "Century Gothic", "Chalkduster", "Colonna MT", "Comic Sans MS", "Consolas", "Constantia", "Copperplate Gothic Light", "Corbel", "Cordia New", "CordiaUPC", "Courier New Baltic", "Courier New CE", "Courier New CYR", "Courier New Greek", "Courier New TUR", "Courier New", "DFKai-SB", "DaunPenh", "David", "DejaVu LGC Sans Mono", "Desdemona", "DilleniaUPC", "DokChampa", "Dotum", "DotumChe", "Ebrima", "Engravers MT", "Eras Bold ITC", "Estrangelo Edessa", "EucrosiaUPC", "Euphemia", "Eurostile", "FangSong", "Forte", "FrankRuehl", "Franklin Gothic Heavy", "Franklin Gothic Medium", "FreesiaUPC", "French Script MT", "Gabriola", "Gautami", "Georgia", "Gigi", "Gisha", "Goudy Old Style", "Gulim", "GulimChe", "GungSeo", "Gungsuh", "GungsuhChe", "Haettenschweiler", "Harrington", "Hei S", "HeiT", "Heisei Kaku Gothic", "Hiragino Sans GB", "Impact", "Informal Roman", "IrisUPC", "Iskoola Pota", "JasmineUPC", "KacstOne", "KaiTi", "Kalinga", "Kartika", "Khmer UI", "Kino MT", "KodchiangUPC", "Kokila", "Kozuka Gothic Pr6N", "Lao UI", "Latha", "Leelawadee", "Levenim MT", "LilyUPC", "Lohit Gujarati", "Loma", "Lucida Bright", "Lucida Console", "Lucida Fax", "Lucida Sans Unicode", "MS Gothic", "MS Mincho", "MS PGothic", "MS PMincho", "MS Reference Sans Serif", "MS UI Gothic", "MV Boli", "Magneto", "Malgun Gothic", "Mangal", "Marlett", "Matura MT Script Capitals", "Meiryo UI", "Meiryo", "Menlo", "Microsoft Himalaya", "Microsoft JhengHei", "Microsoft New Tai Lue", "Microsoft PhagsPa", "Microsoft Sans Serif", "Microsoft Tai Le", "Microsoft Uighur", "Microsoft YaHei", "Microsoft Yi Baiti", "MingLiU", "MingLiU-ExtB", "MingLiU_HKSCS", "MingLiU_HKSCS-ExtB", "Miriam Fixed", "Miriam", "Mongolian Baiti", "MoolBoran", "NSimSun", "Narkisim", "News Gothic MT", "Niagara Solid", "Nyala", "PMingLiU", "PMingLiU-ExtB", "Palace Script MT", "Palatino Linotype", "Papyrus", "Perpetua", "Plantagenet Cherokee", "Playbill", "Prelude Bold", "Prelude Condensed Bold", "Prelude Condensed Medium", "Prelude Medium", "PreludeCompressedWGL Black", "PreludeCompressedWGL Bold", "PreludeCompressedWGL Light", "PreludeCompressedWGL Medium", "PreludeCondensedWGL Black", "PreludeCondensedWGL Bold", "PreludeCondensedWGL Light", "PreludeCondensedWGL Medium", "PreludeWGL Black", "PreludeWGL Bold", "PreludeWGL Light", "PreludeWGL Medium", "Raavi", "Rachana", "Rockwell", "Rod", "Sakkal Majalla", "Sawasdee", "Script MT Bold", "Segoe Print", "Segoe Script", "Segoe UI Light", "Segoe UI Semibold", "Segoe UI Symbol", "Segoe UI", "Shonar Bangla", "Showcard Gothic", "Shruti", "SimHei", "SimSun", "SimSun-ExtB", "Simplified Arabic Fixed", "Simplified Arabic", "Snap ITC", "Sylfaen", "Symbol", "Tahoma", "Times New Roman Baltic", "Times New Roman CE", "Times New Roman CYR", "Times New Roman Greek", "Times New Roman TUR", "Times New Roman", "TlwgMono", "Traditional Arabic", "Trebuchet MS", "Tunga", "Tw Cen MT Condensed Extra Bold", "Ubuntu", "Umpush", "Univers", "Utopia", "Utsaah", "Vani", "Verdana", "Vijaya", "Vladimir Script", "Vrinda", "Webdings", "Wide Latin", "Wingdings"], a = "", o = 0; o < e.length; o++)
          l.detect(e[o]) && (a += o == e.length - 1 ? e[o] : e[o] + ", ");
        return a;
      }, isLocalStorage: function() {
        try {
          return !!u.localStorage;
        } catch {
          return !0;
        }
      }, isSessionStorage: function() {
        try {
          return !!u.sessionStorage;
        } catch {
          return !0;
        }
      }, isCookie: function() {
        return navigator.cookieEnabled;
      }, getTimeZone: function() {
        var e, a;
        return e = /* @__PURE__ */ new Date(), (a = String(-e.getTimezoneOffset() / 60)) < 0 ? "-" + ("0" + (a *= -1)).slice(-2) : "+" + ("0" + a).slice(-2);
      }, getLanguage: function() {
        return navigator.language;
      }, getSystemLanguage: function() {
        return navigator.systemLanguage || window.navigator.language;
      }, isCanvas: function() {
        var e = document.createElement("canvas");
        try {
          return !(!e.getContext || !e.getContext("2d"));
        } catch {
          return !1;
        }
      }, getCanvasPrint: function() {
        var e, a = document.createElement("canvas");
        try {
          e = a.getContext("2d");
        } catch {
          return "";
        }
        var o = "ClientJS,org <canvas> 1.0";
        return e.textBaseline = "top", e.font = "14px 'Arial'", e.textBaseline = "alphabetic", e.fillStyle = "#f60", e.fillRect(125, 1, 62, 20), e.fillStyle = "#069", e.fillText(o, 2, 15), e.fillStyle = "rgba(102, 204, 0, 0.7)", e.fillText(o, 4, 17), a.toDataURL();
      } }, d.ClientJS = _;
    }, function(s, d, n) {
      var i = n(2);
      s.exports = function() {
        return typeof ne == "object" && ne && ne.Math === Math && ne.Array === Array ? ne : i;
      };
    }, function(s, d, n) {
      typeof self < "u" ? s.exports = self : typeof window < "u" ? s.exports = window : s.exports = Function("return this")();
    }, function(s, d, n) {
      s.exports = function(i, l) {
        var u, h, p, P, _, e, a, o;
        for (u = 3 & i.length, h = i.length - u, p = l, _ = 3432918353, e = 461845907, o = 0; o < h; )
          a = 255 & i.charCodeAt(o) | (255 & i.charCodeAt(++o)) << 8 | (255 & i.charCodeAt(++o)) << 16 | (255 & i.charCodeAt(++o)) << 24, ++o, p = 27492 + (65535 & (P = 5 * (65535 & (p = (p ^= a = (65535 & (a = (a = (65535 & a) * _ + (((a >>> 16) * _ & 65535) << 16) & 4294967295) << 15 | a >>> 17)) * e + (((a >>> 16) * e & 65535) << 16) & 4294967295) << 13 | p >>> 19)) + ((5 * (p >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (P >>> 16) & 65535) << 16);
        switch (a = 0, u) {
          case 3:
            a ^= (255 & i.charCodeAt(o + 2)) << 16;
          case 2:
            a ^= (255 & i.charCodeAt(o + 1)) << 8;
          case 1:
            p ^= a = (65535 & (a = (a = (65535 & (a ^= 255 & i.charCodeAt(o))) * _ + (((a >>> 16) * _ & 65535) << 16) & 4294967295) << 15 | a >>> 17)) * e + (((a >>> 16) * e & 65535) << 16) & 4294967295;
        }
        return p ^= i.length, p = 2246822507 * (65535 & (p ^= p >>> 16)) + ((2246822507 * (p >>> 16) & 65535) << 16) & 4294967295, p = 3266489909 * (65535 & (p ^= p >>> 13)) + ((3266489909 * (p >>> 16) & 65535) << 16) & 4294967295, (p ^= p >>> 16) >>> 0;
      };
    }, function(s, d, n) {
      var i;
      (function(l, u) {
        var h = "function", p = "undefined", P = "object", _ = "string", e = "model", a = "name", o = "type", r = "vendor", c = "version", V = "architecture", z = "console", k = "mobile", b = "tablet", D = "smarttv", Z = "wearable", y = "embedded", w = "Amazon", B = "Apple", le = "ASUS", ie = "BlackBerry", Xe = "Firefox", se = "Google", $e = "Huawei", ge = "LG", pe = "Microsoft", Be = "Motorola", Je = "Opera", ve = "Samsung", we = "Sony", Te = "Xiaomi", he = "Zebra", Le = "Facebook", ue = function(M) {
          var L = {};
          for (var $ in M)
            L[M[$].toUpperCase()] = M[$];
          return L;
        }, Ve = function(M, L) {
          return typeof M === _ && oe(L).indexOf(oe(M)) !== -1;
        }, oe = function(M) {
          return M.toLowerCase();
        }, be = function(M, L) {
          if (typeof M === _)
            return M = M.replace(/^\s\s*/, "").replace(/\s\s*$/, ""), typeof L === p ? M : M.substring(0, 255);
        }, ae = function(M, L) {
          for (var $, F, x, S, K, R, ce = 0; ce < L.length && !K; ) {
            var Ie = L[ce], Ae = L[ce + 1];
            for ($ = F = 0; $ < Ie.length && !K; )
              if (K = Ie[$++].exec(M))
                for (x = 0; x < Ae.length; x++)
                  R = K[++F], typeof (S = Ae[x]) === P && S.length > 0 ? S.length == 2 ? typeof S[1] == h ? this[S[0]] = S[1].call(this, R) : this[S[0]] = S[1] : S.length == 3 ? typeof S[1] !== h || S[1].exec && S[1].test ? this[S[0]] = R ? R.replace(S[1], S[2]) : u : this[S[0]] = R ? S[1].call(this, R, S[2]) : u : S.length == 4 && (this[S[0]] = R ? S[3].call(this, R.replace(S[1], S[2])) : u) : this[S] = R || u;
            ce += 2;
          }
        }, ye = function(M, L) {
          for (var $ in L)
            if (typeof L[$] === P && L[$].length > 0) {
              for (var F = 0; F < L[$].length; F++)
                if (Ve(L[$][F], M))
                  return $ === "?" ? u : $;
            } else if (Ve(L[$], M))
              return $ === "?" ? u : $;
          return M;
        }, Pe = { ME: "4.90", "NT 3.11": "NT3.51", "NT 4.0": "NT4.0", 2e3: "NT 5.0", XP: ["NT 5.1", "NT 5.2"], Vista: "NT 6.0", 7: "NT 6.1", 8: "NT 6.2", 8.1: "NT 6.3", 10: ["NT 6.4", "NT 10.0"], RT: "ARM" }, Ee = { browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i], [c, [a, "Chrome"]], [/edg(?:e|ios|a)?\/([\w\.]+)/i], [c, [a, "Edge"]], [/(opera mini)\/([-\w\.]+)/i, /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i, /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i], [a, c], [/opios[\/ ]+([\w\.]+)/i], [c, [a, "Opera Mini"]], [/\bopr\/([\w\.]+)/i], [c, [a, Je]], [/(kindle)\/([\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i, /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i, /(ba?idubrowser)[\/ ]?([\w\.]+)/i, /(?:ms|\()(ie) ([\w\.]+)/i, /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([-\w\.]+)/i, /(weibo)__([\d\.]+)/i], [a, c], [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i], [c, [a, "UCBrowser"]], [/\bqbcore\/([\w\.]+)/i], [c, [a, "WeChat(Win) Desktop"]], [/micromessenger\/([\w\.]+)/i], [c, [a, "WeChat"]], [/konqueror\/([\w\.]+)/i], [c, [a, "Konqueror"]], [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i], [c, [a, "IE"]], [/yabrowser\/([\w\.]+)/i], [c, [a, "Yandex"]], [/(avast|avg)\/([\w\.]+)/i], [[a, /(.+)/, "$1 Secure Browser"], c], [/\bfocus\/([\w\.]+)/i], [c, [a, "Firefox Focus"]], [/\bopt\/([\w\.]+)/i], [c, [a, "Opera Touch"]], [/coc_coc\w+\/([\w\.]+)/i], [c, [a, "Coc Coc"]], [/dolfin\/([\w\.]+)/i], [c, [a, "Dolphin"]], [/coast\/([\w\.]+)/i], [c, [a, "Opera Coast"]], [/miuibrowser\/([\w\.]+)/i], [c, [a, "MIUI Browser"]], [/fxios\/([-\w\.]+)/i], [c, [a, Xe]], [/\bqihu|(qi?ho?o?|360)browser/i], [[a, "360 Browser"]], [/(oculus|samsung|sailfish)browser\/([\w\.]+)/i], [[a, /(.+)/, "$1 Browser"], c], [/(comodo_dragon)\/([\w\.]+)/i], [[a, /_/g, " "], c], [/(electron)\/([\w\.]+) safari/i, /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i, /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i], [a, c], [/(metasr)[\/ ]?([\w\.]+)/i, /(lbbrowser)/i], [a], [/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i], [[a, Le], c], [/safari (line)\/([\w\.]+)/i, /\b(line)\/([\w\.]+)\/iab/i, /(chromium|instagram)[\/ ]([-\w\.]+)/i], [a, c], [/\bgsa\/([\w\.]+) .*safari\//i], [c, [a, "GSA"]], [/headlesschrome(?:\/([\w\.]+)| )/i], [c, [a, "Chrome Headless"]], [/ wv\).+(chrome)\/([\w\.]+)/i], [[a, "Chrome WebView"], c], [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i], [c, [a, "Android Browser"]], [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i], [a, c], [/version\/([\w\.]+) .*mobile\/\w+ (safari)/i], [c, [a, "Mobile Safari"]], [/version\/([\w\.]+) .*(mobile ?safari|safari)/i], [c, a], [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i], [a, [c, ye, { "1.0": "/8", 1.2: "/1", 1.3: "/3", "2.0": "/412", "2.0.2": "/416", "2.0.3": "/417", "2.0.4": "/419", "?": "/" }]], [/(webkit|khtml)\/([\w\.]+)/i], [a, c], [/(navigator|netscape\d?)\/([-\w\.]+)/i], [[a, "Netscape"], c], [/mobile vr; rv:([\w\.]+)\).+firefox/i], [c, [a, "Firefox Reality"]], [/ekiohf.+(flow)\/([\w\.]+)/i, /(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i, /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i, /(firefox)\/([\w\.]+)/i, /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i, /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i, /(links) \(([\w\.]+)/i], [a, c]], cpu: [[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i], [[V, "amd64"]], [/(ia32(?=;))/i], [[V, oe]], [/((?:i[346]|x)86)[;\)]/i], [[V, "ia32"]], [/\b(aarch64|arm(v?8e?l?|_?64))\b/i], [[V, "arm64"]], [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i], [[V, "armhf"]], [/windows (ce|mobile); ppc;/i], [[V, "arm"]], [/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i], [[V, /ower/, "", oe]], [/(sun4\w)[;\)]/i], [[V, "sparc"]], [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i], [[V, oe]]], device: [[/\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i], [e, [r, ve], [o, b]], [/\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i, /samsung[- ]([-\w]+)/i, /sec-(sgh\w+)/i], [e, [r, ve], [o, k]], [/\((ip(?:hone|od)[\w ]*);/i], [e, [r, B], [o, k]], [/\((ipad);[-\w\),; ]+apple/i, /applecoremedia\/[\w\.]+ \((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [e, [r, B], [o, b]], [/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i], [e, [r, $e], [o, b]], [/(?:huawei|honor)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}-[atu]?[ln][01259x][012359][an]?)\b(?!.+d\/s)/i], [e, [r, $e], [o, k]], [/\b(poco[\w ]+)(?: bui|\))/i, /\b; (\w+) build\/hm\1/i, /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i, /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i, /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i], [[e, /_/g, " "], [r, Te], [o, k]], [/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i], [[e, /_/g, " "], [r, Te], [o, b]], [/; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007)\b/i], [e, [r, "OPPO"], [o, k]], [/vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i], [e, [r, "Vivo"], [o, k]], [/\b(rmx[12]\d{3})(?: bui|;|\))/i], [e, [r, "Realme"], [o, k]], [/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i, /\bmot(?:orola)?[- ](\w*)/i, /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i], [e, [r, Be], [o, k]], [/\b(mz60\d|xoom[2 ]{0,2}) build\//i], [e, [r, Be], [o, b]], [/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i], [e, [r, ge], [o, b]], [/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i, /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i, /\blg-?([\d\w]+) bui/i], [e, [r, ge], [o, k]], [/(ideatab[-\w ]+)/i, /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i], [e, [r, "Lenovo"], [o, b]], [/(?:maemo|nokia).*(n900|lumia \d+)/i, /nokia[-_ ]?([-\w\.]*)/i], [[e, /_/g, " "], [r, "Nokia"], [o, k]], [/(pixel c)\b/i], [e, [r, se], [o, b]], [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i], [e, [r, se], [o, k]], [/droid.+ ([c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [e, [r, we], [o, k]], [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i], [[e, "Xperia Tablet"], [r, we], [o, b]], [/ (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i], [e, [r, "OnePlus"], [o, k]], [/(alexa)webm/i, /(kf[a-z]{2}wi)( bui|\))/i, /(kf[a-z]+)( bui|\)).+silk\//i], [e, [r, w], [o, b]], [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i], [[e, /(.+)/g, "Fire Phone $1"], [r, w], [o, k]], [/(playbook);[-\w\),; ]+(rim)/i], [e, r, [o, b]], [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i], [e, [r, ie], [o, k]], [/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i], [e, [r, le], [o, b]], [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i], [e, [r, le], [o, k]], [/(nexus 9)/i], [e, [r, "HTC"], [o, b]], [/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i, /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i, /(alcatel|geeksphone|nexian|panasonic|sony)[-_ ]?([-\w]*)/i], [r, [e, /_/g, " "], [o, k]], [/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i], [e, [r, "Acer"], [o, b]], [/droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i], [e, [r, "Meizu"], [o, k]], [/\b(sh-?[altvz]?\d\d[a-ekm]?)/i], [e, [r, "Sharp"], [o, k]], [/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i, /(hp) ([\w ]+\w)/i, /(asus)-?(\w+)/i, /(microsoft); (lumia[\w ]+)/i, /(lenovo)[-_ ]?([-\w]+)/i, /(jolla)/i, /(oppo) ?([\w ]+) bui/i], [r, e, [o, k]], [/(archos) (gamepad2?)/i, /(hp).+(touchpad(?!.+tablet)|tablet)/i, /(kindle)\/([\w\.]+)/i, /(nook)[\w ]+build\/(\w+)/i, /(dell) (strea[kpr\d ]*[\dko])/i, /(le[- ]+pan)[- ]+(\w{1,9}) bui/i, /(trinity)[- ]*(t\d{3}) bui/i, /(gigaset)[- ]+(q\w{1,9}) bui/i, /(vodafone) ([\w ]+)(?:\)| bui)/i], [r, e, [o, b]], [/(surface duo)/i], [e, [r, pe], [o, b]], [/droid [\d\.]+; (fp\du?)(?: b|\))/i], [e, [r, "Fairphone"], [o, k]], [/(u304aa)/i], [e, [r, "AT&T"], [o, k]], [/\bsie-(\w*)/i], [e, [r, "Siemens"], [o, k]], [/\b(rct\w+) b/i], [e, [r, "RCA"], [o, b]], [/\b(venue[\d ]{2,7}) b/i], [e, [r, "Dell"], [o, b]], [/\b(q(?:mv|ta)\w+) b/i], [e, [r, "Verizon"], [o, b]], [/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i], [e, [r, "Barnes & Noble"], [o, b]], [/\b(tm\d{3}\w+) b/i], [e, [r, "NuVision"], [o, b]], [/\b(k88) b/i], [e, [r, "ZTE"], [o, b]], [/\b(nx\d{3}j) b/i], [e, [r, "ZTE"], [o, k]], [/\b(gen\d{3}) b.+49h/i], [e, [r, "Swiss"], [o, k]], [/\b(zur\d{3}) b/i], [e, [r, "Swiss"], [o, b]], [/\b((zeki)?tb.*\b) b/i], [e, [r, "Zeki"], [o, b]], [/\b([yr]\d{2}) b/i, /\b(dragon[- ]+touch |dt)(\w{5}) b/i], [[r, "Dragon Touch"], e, [o, b]], [/\b(ns-?\w{0,9}) b/i], [e, [r, "Insignia"], [o, b]], [/\b((nxa|next)-?\w{0,9}) b/i], [e, [r, "NextBook"], [o, b]], [/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i], [[r, "Voice"], e, [o, k]], [/\b(lvtel\-)?(v1[12]) b/i], [[r, "LvTel"], e, [o, k]], [/\b(ph-1) /i], [e, [r, "Essential"], [o, k]], [/\b(v(100md|700na|7011|917g).*\b) b/i], [e, [r, "Envizen"], [o, b]], [/\b(trio[-\w\. ]+) b/i], [e, [r, "MachSpeed"], [o, b]], [/\btu_(1491) b/i], [e, [r, "Rotor"], [o, b]], [/(shield[\w ]+) b/i], [e, [r, "Nvidia"], [o, b]], [/(sprint) (\w+)/i], [r, e, [o, k]], [/(kin\.[onetw]{3})/i], [[e, /\./g, " "], [r, pe], [o, k]], [/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i], [e, [r, he], [o, b]], [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i], [e, [r, he], [o, k]], [/(ouya)/i, /(nintendo) ([wids3utch]+)/i], [r, e, [o, z]], [/droid.+; (shield) bui/i], [e, [r, "Nvidia"], [o, z]], [/(playstation [345portablevi]+)/i], [e, [r, we], [o, z]], [/\b(xbox(?: one)?(?!; xbox))[\); ]/i], [e, [r, pe], [o, z]], [/smart-tv.+(samsung)/i], [r, [o, D]], [/hbbtv.+maple;(\d+)/i], [[e, /^/, "SmartTV"], [r, ve], [o, D]], [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i], [[r, ge], [o, D]], [/(apple) ?tv/i], [r, [e, "Apple TV"], [o, D]], [/crkey/i], [[e, "Chromecast"], [r, se], [o, D]], [/droid.+aft(\w)( bui|\))/i], [e, [r, w], [o, D]], [/\(dtv[\);].+(aquos)/i], [e, [r, "Sharp"], [o, D]], [/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i, /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i], [[r, be], [e, be], [o, D]], [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i], [[o, D]], [/((pebble))app/i], [r, e, [o, Z]], [/droid.+; (glass) \d/i], [e, [r, se], [o, Z]], [/droid.+; (wt63?0{2,3})\)/i], [e, [r, he], [o, Z]], [/(quest( 2)?)/i], [e, [r, Le], [o, Z]], [/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i], [r, [o, y]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i], [e, [o, k]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i], [e, [o, b]], [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i], [[o, b]], [/(phone|mobile(?:[;\/]| safari)|pda(?=.+windows ce))/i], [[o, k]], [/(android[-\w\. ]{0,9});.+buil/i], [e, [r, "Generic"]]], engine: [[/windows.+ edge\/([\w\.]+)/i], [c, [a, "EdgeHTML"]], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i], [c, [a, "Blink"]], [/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, /ekioh(flow)\/([\w\.]+)/i, /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i, /(icab)[\/ ]([23]\.[\d\.]+)/i], [a, c], [/rv\:([\w\.]{1,9})\b.+(gecko)/i], [c, a]], os: [[/microsoft (windows) (vista|xp)/i], [a, c], [/(windows) nt 6\.2; (arm)/i, /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i, /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i], [a, [c, ye, Pe]], [/(win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[a, "Windows"], [c, ye, Pe]], [/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i, /cfnetwork\/.+darwin/i], [[c, /_/g, "."], [a, "iOS"]], [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i], [[a, "Mac OS"], [c, /_/g, "."]], [/droid ([\w\.]+)\b.+(android[- ]x86)/i], [c, a], [/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i, /(tizen|kaios)[\/ ]([\w\.]+)/i, /\((series40);/i], [a, c], [/\(bb(10);/i], [c, [a, ie]], [/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i], [c, [a, "Symbian"]], [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i], [c, [a, "Firefox OS"]], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i], [c, [a, "webOS"]], [/crkey\/([\d\.]+)/i], [c, [a, "Chromecast"]], [/(cros) [\w]+ ([\w\.]+\w)/i], [[a, "Chromium OS"], c], [/(nintendo|playstation) ([wids345portablevuch]+)/i, /(xbox); +xbox ([^\);]+)/i, /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i, /(mint)[\/\(\) ]?(\w*)/i, /(mageia|vectorlinux)[; ]/i, /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i, /(hurd|linux) ?([\w\.]*)/i, /(gnu) ?([\w\.]*)/i, /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, /(haiku) (\w+)/i], [a, c], [/(sunos) ?([\w\.\d]*)/i], [[a, "Solaris"], c], [/((?:open)?solaris)[-\/ ]?([\w\.]*)/i, /(aix) ((\d)(?=\.|\)| )[\w\.])*/i, /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i, /(unix) ?([\w\.]*)/i], [a, c]] }, U = function(M, L) {
          if (typeof M === P && (L = M, M = u), !(this instanceof U))
            return new U(M, L).getResult();
          var $ = M || (typeof l !== p && l.navigator && l.navigator.userAgent ? l.navigator.userAgent : ""), F = L ? function(x, S) {
            var K = {};
            for (var R in x)
              S[R] && S[R].length % 2 == 0 ? K[R] = S[R].concat(x[R]) : K[R] = x[R];
            return K;
          }(Ee, L) : Ee;
          return this.getBrowser = function() {
            var x, S = {};
            return S.name = u, S.version = u, ae.call(S, $, F.browser), S.major = typeof (x = S.version) === _ ? x.replace(/[^\d\.]/g, "").split(".")[0] : u, S;
          }, this.getCPU = function() {
            var x = {};
            return x.architecture = u, ae.call(x, $, F.cpu), x;
          }, this.getDevice = function() {
            var x = {};
            return x.vendor = u, x.model = u, x.type = u, ae.call(x, $, F.device), x;
          }, this.getEngine = function() {
            var x = {};
            return x.name = u, x.version = u, ae.call(x, $, F.engine), x;
          }, this.getOS = function() {
            var x = {};
            return x.name = u, x.version = u, ae.call(x, $, F.os), x;
          }, this.getResult = function() {
            return { ua: this.getUA(), browser: this.getBrowser(), engine: this.getEngine(), os: this.getOS(), device: this.getDevice(), cpu: this.getCPU() };
          }, this.getUA = function() {
            return $;
          }, this.setUA = function(x) {
            return $ = typeof x === _ && x.length > 255 ? be(x, 255) : x, this;
          }, this.setUA($), this;
        };
        U.VERSION = "0.7.30", U.BROWSER = ue([a, c, "major"]), U.CPU = ue([V]), U.DEVICE = ue([e, r, o, z, k, D, b, Z, y]), U.ENGINE = U.OS = ue([a, c]), typeof d !== p ? (typeof s !== p && s.exports && (d = s.exports = U), d.UAParser = U) : n(5) ? (i = (function() {
          return U;
        }).call(d, n, d, s)) === u || (s.exports = i) : typeof l !== p && (l.UAParser = U);
        var te = typeof l !== p && (l.jQuery || l.Zepto);
        if (te && !te.ua) {
          var de = new U();
          te.ua = de.getResult(), te.ua.get = function() {
            return de.getUA();
          }, te.ua.set = function(M) {
            de.setUA(M);
            var L = de.getResult();
            for (var $ in L)
              te.ua[$] = L[$];
          };
        }
      })(typeof window == "object" ? window : this);
    }, function(s, d) {
      (function(n) {
        s.exports = n;
      }).call(this, {});
    }, function(s, d) {
      s.exports = function() {
        var n = ["monospace", "sans-serif", "serif"], i = document.getElementsByTagName("body")[0], l = document.createElement("span");
        l.style.fontSize = "72px", l.innerHTML = "mmmmmmmmmmlli";
        var u = {}, h = {};
        for (var p in n)
          l.style.fontFamily = n[p], i.appendChild(l), u[n[p]] = l.offsetWidth, h[n[p]] = l.offsetHeight, i.removeChild(l);
        this.detect = function(P) {
          var _ = !1;
          for (var e in n) {
            l.style.fontFamily = P + "," + n[e], i.appendChild(l);
            var a = l.offsetWidth != u[n[e]] || l.offsetHeight != h[n[e]];
            i.removeChild(l), _ = _ || a;
          }
          return _;
        };
      };
    }]);
  });
})(We);
var Ze = We.exports;
function Tt({ maxlength: t, allowLineBreak: g = !1 }) {
  const s = new Ze.ClientJS();
  function d(n, i, l) {
    const [u] = l.getTargetRanges(), h = t - i.length + u.endOffset - u.startOffset;
    return n.slice(0, h);
  }
  return {
    handleInputEvent(n) {
      var u, h;
      const i = n.currentTarget;
      if (s.isSafari() && n.inputType === "insertText") {
        const p = (u = i.innerText) == null ? void 0 : u.length, [P] = n.getTargetRanges(), _ = P.endOffset - P.startOffset;
        p && p - _ >= t && n.preventDefault();
        return;
      }
      if (!/^insert/.test(n.inputType) || g && n.inputType === "insertLineBreak" && ((h = i.innerText) == null ? void 0 : h.length) < t)
        return;
      n.preventDefault();
      let l = n.data ?? "";
      if (!n.data && n.dataTransfer instanceof DataTransfer && (l = n.dataTransfer.getData("text/plain")), l = d(l, i.innerText ?? "", n), l.length === 0)
        return !0;
      document.execCommand("insertText", void 0, l);
    },
    insertLineBreakIfAllowed(n) {
      var l;
      const i = n.currentTarget;
      g && ((l = i.innerText) == null ? void 0 : l.length) < t && (n.preventDefault(), document.execCommand("insertLineBreak"));
    }
  };
}
const Lt = ["title"], Vt = { class: "relative max-w-full" }, Pt = ["contenteditable"], Et = /* @__PURE__ */ O({
  __name: "InlineEditable",
  props: {
    placeholder: {
      type: String,
      default: "Start typing…"
    },
    value: {
      type: String,
      default: ""
    },
    error: {
      type: Boolean,
      default: !1
    },
    maxlength: {
      type: Number,
      default: 255
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    theme: {
      type: String,
      default: "light"
    },
    minwidth: {
      type: String,
      default: "inherit"
    },
    focusOnMount: {
      type: Boolean,
      default: !1
    },
    allowLineBreak: {
      type: Boolean,
      default: !1
    },
    noBlurElement: {
      type: String,
      default: null
    }
  },
  emits: [
    "focus",
    "blur",
    "input",
    "dblclick",
    "click",
    "save",
    "no-blur-save",
    "cancel",
    "shift-click",
    "ctrl-click",
    "clear",
    "mousedown",
    "enter-key",
    "update:value"
  ],
  setup(t, { emit: g }) {
    const s = t, d = g, n = E(), i = E(!1), l = E(), u = E(!1), h = E(s.disabled), p = E(!1);
    function P(y) {
      var ie;
      const w = y.relatedTarget, B = w ? (ie = l.value) == null ? void 0 : ie.contains(w) : !1, le = s.noBlurElement && w ? w.closest(s.noBlurElement) : !1;
      return B || le;
    }
    function _() {
      var y, w;
      n.value && (n.value.scrollLeft = 0, n.value.blur(), n.value.innerText = ((y = n.value.innerText) == null ? void 0 : y.trim()) ?? null), (w = document.getSelection()) == null || w.removeAllRanges(), d("blur");
    }
    function e(y) {
      var w, B;
      if (!h.value) {
        if (P(y)) {
          d("no-blur-save");
          return;
        }
        if (!((B = (w = n.value) == null ? void 0 : w.innerText) != null && B.trim())) {
          d("clear"), _();
          return;
        }
        u.value && (d("save"), u.value = !1), _();
      }
    }
    function a(y) {
      d("cancel", { explicit: y }), u.value = !1, et(_);
    }
    function o(y) {
      if (y instanceof InputEvent && y.inputType === "insertParagraph")
        return y.preventDefault(), d("enter-key"), _(), i.value = !1, !0;
    }
    const { handleInputEvent: r, insertLineBreakIfAllowed: c } = Tt({
      maxlength: s.maxlength,
      allowLineBreak: s.allowLineBreak
    });
    Y(
      [() => s.value, n],
      ([y, w]) => {
        w && y !== w.innerText && (w.innerText = y);
      },
      { immediate: !0 }
    ), Y(
      () => s.disabled,
      (y) => {
        h.value = y;
      }
    ), Y(
      [() => s.focusOnMount, n],
      ([y, w]) => {
        y && w && (w.focus(), i.value = !0);
      },
      { immediate: !0 }
    );
    function V(y) {
      var w, B;
      d("input", (w = n.value) == null ? void 0 : w.innerText), d("update:value", (B = n.value) == null ? void 0 : B.innerText);
    }
    function z(y) {
      h.value || d("focus", y);
    }
    function k(y) {
      var w;
      (w = n.value) == null || w.focus(), i.value = !0, d("dblclick", y);
    }
    function b(y) {
      d("click", y);
    }
    function D(y) {
      (!new Ze.ClientJS().isSafari() || !p.value) && (o(y) || r(y)) || (u.value = !0);
    }
    function Z(y) {
      i.value && y.stopPropagation();
    }
    return (y, w) => (f(), v("span", Ce(y.$attrs, {
      ref_key: "containerElement",
      ref: l,
      class: ["ui-inline-editable inline-block focus-within_cursor-auto border-box border border-transparent transition-colors", [{ error: t.error }, t.theme, h.value ? "select-none" : "cursor-text"]],
      title: t.value,
      role: "input",
      tabindex: "0",
      onClick: b,
      onDblclick: k,
      onMousedown: w[10] || (w[10] = (B) => y.$emit("mousedown", B))
    }), [
      m("div", Vt, [
        m("div", {
          ref_key: "inputElement",
          ref: n,
          class: "editable overflow-hidden overflow-ellipsis max-w-full focus_overflow-clip break-words",
          spellcheck: "false",
          "data-testid": "input-element",
          style: J({ "--placeholder-text": `'${t.placeholder}'`, "min-width": `${t.minwidth}` }),
          contenteditable: !h.value,
          onClick: [
            w[0] || (w[0] = H((B) => h.value = t.disabled, ["exact"])),
            w[1] || (w[1] = H((B) => (y.$emit("shift-click", B), h.value = !0), ["shift", "left", "exact"])),
            w[2] || (w[2] = H((B) => (y.$emit("ctrl-click", B), h.value = !0), ["ctrl", "left", "exact"])),
            w[3] || (w[3] = H((B) => (y.$emit("ctrl-click", B), h.value = !0), ["meta", "left", "exact"]))
          ],
          onFocus: z,
          onBlur: e,
          onKeyup: [
            w[4] || (w[4] = fe((B) => a(!0), ["esc"])),
            w[5] || (w[5] = (B) => p.value = !1)
          ],
          onKeydown: [
            w[6] || (w[6] = fe(H((B) => p.value = !0, ["shift"]), ["enter"])),
            w[7] || (w[7] = fe(H((B) => (T(c)(B), p.value = !0), ["meta"]), ["enter"])),
            w[8] || (w[8] = fe(H((B) => T(c)(B), ["ctrl"]), ["enter"]))
          ],
          onBeforeinput: D,
          onInput: V,
          onContextmenu: Z
        }, null, 44, Pt),
        t.error ? (f(), A(T(He), {
          key: 0,
          class: "h-4 select-none text-red-800 ml-1",
          "data-testid": "error-icon",
          onMousedown: w[9] || (w[9] = H(() => {
          }, ["self", "prevent"]))
        })) : I("", !0)
      ])
    ], 16, Lt));
  }
});
const Rn = /* @__PURE__ */ j(Et, [["__scopeId", "data-v-cd4f42d0"]]), It = (t) => (_e("data-v-4204496a"), t = t(), Me(), t), At = {
  class: "flex items-end pointer-events-none sm_items-start z-50",
  "aria-live": "assertive"
}, Nt = { class: "w-full flex flex-col items-center space-y-4 sm_items-end" }, Dt = { class: "flex-shrink-0" }, Rt = { class: "ml-3 w-0 flex-1 pt-0.5" }, Ot = {
  key: 1,
  class: "mt-1 mb-0 text-sm text-gray-700"
}, jt = {
  key: 0,
  class: "ml-4 flex-shrink-0 flex"
}, Ut = /* @__PURE__ */ It(() => /* @__PURE__ */ m("span", { class: "sr-only" }, "Close", -1)), zt = /* @__PURE__ */ O({
  __name: "VNotification",
  props: {
    show: {
      type: Boolean,
      default: !0
    },
    dismissible: {
      type: [Boolean, String],
      default: !0
    },
    delay: {
      type: Number,
      default: 0
    },
    focused: {
      type: [Boolean, String],
      default: !1
    },
    translucent: {
      type: [Boolean, String],
      default: !1
    },
    type: {
      type: String,
      default: "success"
    },
    variant: {
      type: String,
      default: ""
    }
  },
  emits: ["dismissed"],
  setup(t, { emit: g }) {
    const s = t, d = g;
    let n = null;
    const i = E(s.show);
    return Y(i, (l) => {
      l || (n && (clearTimeout(n), n = null), d("dismissed"));
    }), Y(
      Ue(s, "show"),
      (l) => {
        i.value = l, !(!l || !s.delay) && (n && (clearTimeout(n), n = null), n = setTimeout(() => i.value = !1, s.delay));
      },
      { immediate: !0 }
    ), (l, u) => (f(), v("div", At, [
      m("div", Nt, [
        G(ze, {
          "enter-active-class": "transition duration-300 ease-out transform",
          "enter-class": "translate-y-2 opacity-0 sm_translate-y-0 sm_translate-x-2",
          "enter-to-class": "translate-y-0 opacity-100 sm_translate-x-0",
          "leave-active-class": "transition duration-100 ease-in",
          "leave-class": "opacity-100",
          "leave-to-class": "opacity-0"
        }, {
          default: W(() => [
            i.value ? (f(), v("div", {
              key: 0,
              class: N(["w-full flex items-start p-4 bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden", { focused: t.focused, translucent: t.translucent }]),
              "data-testid": "v-notification-content",
              style: J([{ "background-color": t.variant === "dark" ? "#222222" : "" }])
            }, [
              m("div", Dt, [
                t.type ? C(l.$slots, "icon", { key: 0 }, () => [
                  t.type === "danger" ? (f(), A(T(st), {
                    key: 0,
                    class: "w-6 text-red-700"
                  })) : t.type === "warning" ? (f(), A(T(ut), {
                    key: 1,
                    class: "w-6 text-yellow-300"
                  })) : t.type === "info" ? (f(), A(T(ft), {
                    key: 2,
                    class: "w-6 text-blue-700"
                  })) : (f(), A(T(Fe), {
                    key: 3,
                    class: "w-6 text-copper-700"
                  }))
                ], !0) : I("", !0)
              ]),
              m("div", Rt, [
                l.$slots.title ? (f(), v("p", {
                  key: 0,
                  class: "text-sm font-medium text-gray-900 mb-0",
                  style: J([{ color: t.variant === "dark" ? "#ffffff" : "" }])
                }, [
                  C(l.$slots, "title", {}, void 0, !0)
                ], 4)) : I("", !0),
                l.$slots.default ? (f(), v("p", Ot, [
                  C(l.$slots, "default", {}, void 0, !0)
                ])) : I("", !0)
              ]),
              t.dismissible ? (f(), v("div", jt, [
                C(l.$slots, "button", {}, () => [
                  m("button", {
                    class: "bg-white rounded-md inline-flex text-gray-400 hover_text-gray-500 focus_outline-none focus_ring-2 focus_ring-offset-2 focus_ring-indigo-500",
                    "data-testid": "v-notification-close",
                    style: J([{ "background-color": t.variant === "dark" ? "#222222" : "" }]),
                    onClick: u[0] || (u[0] = (h) => i.value = !1)
                  }, [
                    Ut,
                    G(T(ke), { class: "w-6" })
                  ], 4)
                ], !0)
              ])) : I("", !0)
            ], 6)) : I("", !0)
          ]),
          _: 3
        })
      ])
    ]));
  }
});
const On = /* @__PURE__ */ j(zt, [["__scopeId", "data-v-4204496a"]]), X = {};
function Ft({ shouldStopScroll: t }) {
  const g = Symbol();
  X[g] = !1, Y(
    t,
    () => {
      document.body && (t.value ? (X[g] = !0, document.body.style.overflow = "hidden") : (X[g] = !1, Object.getOwnPropertySymbols(X).find((d) => X[d]) || (document.body.style.overflow = "")));
    },
    { immediate: !0 }
  ), Se(() => {
    delete X[g], document.body && (Object.getOwnPropertySymbols(X).find((d) => X[d]) || (document.body.style.overflow = ""));
  });
}
const Ke = (t) => (_e("data-v-fa0336f2"), t = t(), Me(), t), Gt = { class: "v-modal__mask flex items-center justify-center min-h-screen text-center" }, qt = { class: "flex flex-row-reverse sm_bg-gray-100 rounded-tl-lg rounded-tr-lg" }, Ht = /* @__PURE__ */ Ke(() => /* @__PURE__ */ m("span", { class: "sr-only" }, "Close", -1)), Wt = {
  key: 0,
  class: "flex-grow p-4 pt-5 sm_p-6 min-w-0"
}, Zt = /* @__PURE__ */ Ke(() => /* @__PURE__ */ m("span", { class: "sr-only" }, "Close", -1)), Kt = /* @__PURE__ */ O({
  __name: "VModal",
  props: {
    showing: {
      type: Boolean,
      default: !1
    },
    mobileFullscreen: {
      type: [Boolean, String],
      default: !1
    },
    hideClose: {
      type: [Boolean, String],
      default: !1
    },
    containerClasses: {
      type: String,
      default: ""
    },
    maxContent: {
      type: String,
      default: "none"
    },
    overflowContent: {
      type: [Boolean, String],
      default: !1
    },
    borderedFooter: {
      type: [Boolean, String],
      default: !1
    },
    confined: {
      type: [Boolean, String],
      default: !1
    }
  },
  emits: ["update:showing"],
  setup(t, { emit: g }) {
    var p, P, _;
    const s = t, d = g, n = xe();
    Ft({ shouldStopScroll: Ue(s, "showing") });
    const i = E((p = n.header) == null ? void 0 : p.call(n)), l = E((P = n.default) == null ? void 0 : P.call(n)), u = E((_ = n.footer) == null ? void 0 : _.call(n));
    tt(() => {
      var e, a, o;
      i.value = (e = n.header) == null ? void 0 : e.call(n), l.value = (a = n.default) == null ? void 0 : a.call(n), u.value = (o = n.footer) == null ? void 0 : o.call(n);
    });
    const h = (e) => {
      s.showing && e.key === "Escape" && d("update:showing", !1);
    };
    return me(() => {
      document.addEventListener("keydown", h);
    }), Se(() => {
      document.removeEventListener("keydown", h);
    }), (e, a) => (f(), A(ze, { name: "modal" }, {
      default: W(() => [
        t.showing ? (f(), v("div", {
          key: 0,
          class: N(["v-modal min-h-screen inset-0", { "overflow-hidden": !t.overflowContent, "mobile-fullscreen": t.mobileFullscreen, fixed: !t.confined }]),
          role: "dialog",
          "aria-modal": "true"
        }, [
          m("div", Gt, [
            m("div", {
              class: N(["v-modal__container bg-white text-left shadow-xl transform transition-all relative sm_align-middle", [t.containerClasses, { "overflow-hidden": !t.overflowContent }]])
            }, [
              m("div", qt, [
                C(e.$slots, "closeBtn", {}, () => [
                  t.hideClose === !1 && i.value ? (f(), v("button", {
                    key: 0,
                    class: "p-0 m-4 mt-5 sm_m-6 bg-transparent rounded-md text-gray-900 z-10 hover_text-gray-600 sm_top-6 sm_right-6 self-start align-center focus_outline-none",
                    type: "button",
                    "data-testid": "modal-close-btn",
                    onClick: a[0] || (a[0] = (o) => e.$emit("update:showing", !1))
                  }, [
                    Ht,
                    G(T(ke), { class: "w-6" })
                  ])) : I("", !0)
                ], !0),
                i.value ? (f(), v("header", Wt, [
                  C(e.$slots, "header", {}, void 0, !0)
                ])) : I("", !0)
              ]),
              l.value ? (f(), v("div", {
                key: 0,
                class: N(["v-modal__content p-4 pt-5 sm_p-6", { "overflow-y-auto": !t.overflowContent }]),
                style: J({ maxHeight: t.maxContent })
              }, [
                t.hideClose === !1 && !i.value ? (f(), v("button", {
                  key: 0,
                  class: "p-0 bg-transparent rounded-md text-gray-900 z-10 hover_text-gray-600 sm_top-6 sm_right-6 absolute right-4 focus_outline-none",
                  type: "button",
                  "data-testid": "modal-close-btn",
                  onClick: a[1] || (a[1] = (o) => e.$emit("update:showing", !1))
                }, [
                  Zt,
                  G(T(ke), { class: "w-6" })
                ])) : I("", !0),
                C(e.$slots, "default", {}, void 0, !0)
              ], 6)) : I("", !0),
              u.value ? (f(), v("footer", {
                key: 1,
                class: N(["p-4 pt-5 sm_p-6", { "bg-gray-100": !t.borderedFooter, "border-gray-200 border-t": t.borderedFooter }])
              }, [
                C(e.$slots, "footer", {}, void 0, !0)
              ], 2)) : I("", !0)
            ], 2)
          ])
        ], 2)) : I("", !0)
      ]),
      _: 3
    }));
  }
});
const Xt = /* @__PURE__ */ j(Kt, [["__scopeId", "data-v-fa0336f2"]]), Jt = {}, Yt = { class: "text-lg font-medium text-gray-900 mb-0" }, Qt = { class: "text-sm text-gray-700 mb-0" };
function en(t, g) {
  return f(), v("hgroup", null, [
    m("h2", Yt, [
      C(t.$slots, "title")
    ]),
    m("p", Qt, [
      C(t.$slots, "sub-title")
    ])
  ]);
}
const jn = /* @__PURE__ */ j(Jt, [["render", en]]);
function tn(t, g) {
  return f(), v("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "fill-rule": "evenodd",
      d: "M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
const Un = /* @__PURE__ */ O({
  __name: "FlyoutMenu",
  props: {
    title: {
      type: String,
      default: ""
    },
    menuClass: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const g = E(null), s = E(!1);
    function d(n) {
      var i;
      n.target !== g.value && !((i = g.value) != null && i.contains(n.target)) && (s.value = !1);
    }
    return me(async () => {
      document.addEventListener("click", d);
    }), nt(() => {
      document.removeEventListener("click", d);
    }), (n, i) => (f(), v("li", {
      ref_key: "flyoutMenuRef",
      ref: g,
      class: "relative"
    }, [
      m("button", {
        type: "button",
        class: "appearance-none bg-transparent flex items-center hover_text-gray-600",
        onClick: i[0] || (i[0] = (l) => s.value = !s.value)
      }, [
        C(n.$slots, "button", {}, () => [
          re(ee(t.title) + " ", 1),
          G(T(tn), { class: "w-6" })
        ])
      ]),
      m("menu", {
        class: N(["absolute top-8 my-3.5 z-50 transform opacity-0 translate-y-0 transition-all bg-white rounded-lg shadow-lg ring-1 ring-gray-200 duration-75", [t.menuClass, { invisible: !s.value, "opacity-100": s.value, "translate-y-1": !s.value }]]),
        onClick: i[1] || (i[1] = (l) => s.value = !s.value)
      }, [
        C(n.$slots, "default")
      ], 2)
    ], 512));
  }
}), q = (t) => (_e("data-v-1e367481"), t = t(), Me(), t), nn = { class: "loading-spinner" }, on = /* @__PURE__ */ q(() => /* @__PURE__ */ m("div", null, null, -1)), an = /* @__PURE__ */ q(() => /* @__PURE__ */ m("div", null, null, -1)), rn = /* @__PURE__ */ q(() => /* @__PURE__ */ m("div", null, null, -1)), ln = /* @__PURE__ */ q(() => /* @__PURE__ */ m("div", null, null, -1)), sn = /* @__PURE__ */ q(() => /* @__PURE__ */ m("div", null, null, -1)), un = /* @__PURE__ */ q(() => /* @__PURE__ */ m("div", null, null, -1)), dn = /* @__PURE__ */ q(() => /* @__PURE__ */ m("div", null, null, -1)), cn = /* @__PURE__ */ q(() => /* @__PURE__ */ m("div", null, null, -1)), fn = /* @__PURE__ */ q(() => /* @__PURE__ */ m("div", null, null, -1)), mn = /* @__PURE__ */ q(() => /* @__PURE__ */ m("div", null, null, -1)), gn = /* @__PURE__ */ q(() => /* @__PURE__ */ m("div", null, null, -1)), pn = /* @__PURE__ */ q(() => /* @__PURE__ */ m("div", null, null, -1)), vn = [
  on,
  an,
  rn,
  ln,
  sn,
  un,
  dn,
  cn,
  fn,
  mn,
  gn,
  pn
], wn = /* @__PURE__ */ O({
  __name: "LoadingSpinner",
  props: {
    hasBackground: {
      type: Boolean,
      default: !0
    },
    size: {
      type: String,
      default: "md"
    }
  },
  setup(t) {
    return (g, s) => (f(), v("div", nn, [
      m("div", {
        class: N(["loading-spinner__container", { background: t.hasBackground }])
      }, [
        m("div", {
          class: N(["loading-spinner__icon", t.size])
        }, vn, 2)
      ], 2)
    ]));
  }
});
const zn = /* @__PURE__ */ j(wn, [["__scopeId", "data-v-1e367481"]]), hn = {
  key: 0,
  class: "flex flex-row items-end justify-between mb-2"
}, bn = { class: "font-normal" }, yn = {
  key: 0,
  class: "text-xs font-medium text-gray-500",
  type: "optional"
}, kn = ["data-testid"], Fn = /* @__PURE__ */ O({
  __name: "FormField",
  props: {
    label: {
      type: String,
      default: null
    },
    required: {
      type: [String, Boolean],
      default: !1
    },
    modelValue: {
      type: [String, Number],
      default: null
    },
    attrs: {
      type: Object,
      default: () => ({})
    },
    placeholder: {
      type: String,
      default: ""
    },
    error: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: "text"
    },
    autocomplete: {
      type: String,
      default: "false"
    },
    maxlength: {
      type: [String, Number],
      default: null
    },
    rows: {
      type: [String, Number],
      default: null
    },
    step: {
      type: [String, Number],
      default: null
    }
  },
  emits: ["input", "update:modelValue"],
  setup(t, { emit: g }) {
    const s = g;
    function d(n) {
      s("update:modelValue", n.target.value);
    }
    return (n, i) => (f(), v("div", {
      class: N(["flex flex-col text-sm text-gray-900 form-field", { optional: t.required === !1 }])
    }, [
      t.label ? (f(), v("div", hn, [
        m("label", bn, ee(t.label), 1),
        t.required === !1 ? (f(), v("label", yn, "Optional")) : I("", !0)
      ])) : I("", !0),
      C(n.$slots, "default", {}, () => [
        G(Ct, Ce({ "model-value": t.modelValue }, t.attrs, {
          class: ["input", { error: t.error }],
          step: t.step,
          type: t.type,
          placeholder: t.placeholder,
          error: !!t.error,
          autocomplete: t.autocomplete,
          maxlength: t.maxlength,
          rows: t.rows,
          onInput: d
        }), {
          button: W(() => [
            C(n.$slots, "button")
          ]),
          _: 3
        }, 16, ["model-value", "step", "type", "placeholder", "error", "class", "autocomplete", "maxlength", "rows"])
      ]),
      t.error ? (f(), v("div", {
        key: 1,
        "data-testid": `${(t.label || "form-field").toLowerCase()}-error`,
        class: "error"
      }, [
        C(n.$slots, "error", {}, () => [
          re(ee(t.error), 1)
        ])
      ], 8, kn)) : I("", !0)
    ], 2));
  }
});
const xn = { class: "flex p-6 gap-6 pb-0 rounded-t-lg" }, Sn = { class: "flex flex-col rounded-t-lg truncate w-full" }, Cn = {
  class: "truncate text-lg font-medium leading-6 text-gray-900 mb-4",
  style: { "max-width": "90%" }
}, _n = { class: "text-sm text-gray-700 text-left leading-6 whitespace-normal" }, Mn = { class: "flex items-center justify-end space-x-4" }, $n = {
  key: 0,
  class: "space-x-4"
}, Bn = { key: 1 }, Tn = /* @__PURE__ */ O({
  __name: "ModalsConfirmation",
  props: /* @__PURE__ */ Ne({
    info: {
      type: Boolean,
      required: !1
    },
    theme: {
      required: !1,
      type: String,
      default: null
    },
    width: {
      type: String,
      default: "max-w-xl"
    }
  }, {
    showing: { type: Boolean, required: !0 },
    showingModifiers: {}
  }),
  emits: /* @__PURE__ */ Ne(["confirm"], ["update:showing"]),
  setup(t, { emit: g }) {
    const s = it(t, "showing"), d = g;
    function n() {
      d("confirm"), s.value = !1;
    }
    return (i, l) => (f(), A(Xt, {
      showing: s.value,
      "onUpdate:showing": l[2] || (l[2] = (u) => s.value = u)
    }, {
      footer: W(() => [
        m("div", Mn, [
          C(i.$slots, "actions", {}, () => [
            t.info ? (f(), v("div", Bn, [
              m("button", {
                theme: "primary",
                onClick: l[1] || (l[1] = (u) => s.value = !1)
              }, "Okay")
            ])) : (f(), v("div", $n, [
              G(T(De), {
                onClick: l[0] || (l[0] = (u) => s.value = !1)
              }, {
                default: W(() => [
                  re("Cancel")
                ]),
                _: 1
              }),
              G(T(De), {
                variant: t.theme === "danger" ? "danger" : "copper",
                onClick: n
              }, {
                default: W(() => [
                  re("Confirm")
                ]),
                _: 1
              }, 8, ["variant"])
            ]))
          ], !0)
        ])
      ]),
      default: W(() => [
        m("div", xn, [
          t.theme ? (f(), v("div", {
            key: 0,
            class: N(["flex flex-shrink-0 justify-center items-center rounded-full h-10 w-10", t.theme])
          }, [
            t.theme === "warning" ? (f(), A(T(Re), {
              key: 0,
              class: "h-7 w-7"
            })) : t.theme === "success" ? (f(), A(T(Fe), {
              key: 1,
              class: "h-7 w-7"
            })) : t.theme === "danger" ? (f(), A(T(Re), {
              key: 2,
              class: "h-7 w-7"
            })) : t.theme === "info" ? (f(), A(T(lt), {
              key: 3,
              class: "h-7 w-7"
            })) : I("", !0)
          ], 2)) : I("", !0),
          m("div", Sn, [
            m("h3", Cn, [
              C(i.$slots, "title", {}, void 0, !0)
            ]),
            m("p", _n, [
              C(i.$slots, "message", {}, void 0, !0)
            ])
          ])
        ])
      ]),
      _: 3
    }, 8, ["showing"]));
  }
});
const Gn = /* @__PURE__ */ j(Tn, [["__scopeId", "data-v-5f54f597"]]), Ln = /* @__PURE__ */ O({
  __name: "VCollapsible",
  props: {
    initialCollapsed: {
      type: Boolean,
      default: !1
    },
    collapsedBackgroundClass: {
      type: String,
      default: "bg-gray-900"
    },
    collapseDirection: {
      type: String,
      default: "up"
    }
  },
  setup(t, { expose: g }) {
    const s = E(null);
    g({ toggleBtnRef: s });
    const n = E(t.initialCollapsed);
    function i() {
      n.value = !n.value;
    }
    return (l, u) => (f(), v("div", {
      class: N(["collapsible-container", t.collapseDirection, n.value ? "collapsed" : "expanded", t.collapsedBackgroundClass])
    }, [
      m("div", {
        class: N([n.value ? "collapsed-content" : "expanded-content"])
      }, [
        C(l.$slots, "default", {}, void 0, !0)
      ], 2),
      m("button", {
        ref_key: "toggleBtnRef",
        ref: s,
        type: "button",
        class: N([t.collapseDirection, "toggle-btn", n.value ? "collapsed" : "expanded"]),
        onClick: i
      }, [
        n.value ? (f(), A(T(qe), {
          key: 0,
          class: "collapsed-arrow-icon h-4 w-4"
        })) : (f(), A(T(rt), {
          key: 1,
          class: "expanded-arrow-icon h-4 w-4"
        }))
      ], 2)
    ], 2));
  }
});
const Oe = /* @__PURE__ */ j(Ln, [["__scopeId", "data-v-894311f3"]]), Vn = { class: "flex flex-grow" }, Pn = /* @__PURE__ */ O({
  __name: "ContainerResizer",
  props: {
    enableLeftCollapse: {
      type: Boolean,
      default: !1
    },
    enableRightCollapse: {
      type: Boolean,
      default: !1
    }
  },
  setup(t, { expose: g }) {
    const s = xe(), d = E(), n = E(), i = E(), l = E();
    g({ leftSideSlot: d, rightSideSlot: n, leftVCollapsibleRef: i, rightVCollapsibleRef: l });
    let u, h = 0, p = 0;
    const P = (r, c) => {
      var V, z, k, b, D;
      c.preventDefault(), c.stopPropagation(), u = r ? (V = d.value) == null ? void 0 : V.children[0] : (z = n.value) == null ? void 0 : z.children[0], u instanceof HTMLDivElement && (h = ((b = (k = u == null ? void 0 : u.getBoundingClientRect) == null ? void 0 : k.call(u)) == null ? void 0 : b.width) ?? 0, p = c.clientX, document.body.classList.add("is-dragging"), (D = u.classList) == null || D.add("pointer-events-none"), document.addEventListener("mousemove", _), document.addEventListener("mouseup", e));
    }, _ = function(r) {
      var V;
      if (!u)
        return;
      let c = r.clientX - p;
      u === ((V = d.value) == null ? void 0 : V.children[0]) && (c *= -1), u.style.width = `${h - c}px`;
    }, e = function() {
      var r;
      u && (document.body.classList.remove("is-dragging"), (r = u.classList) == null || r.remove("pointer-events-none"), document.removeEventListener("mousemove", _), document.removeEventListener("mouseup", e), u = void 0, h = 0);
    }, a = Q(() => {
      var r;
      return (r = s.leftSide) == null ? void 0 : r.call(s);
    }), o = Q(() => {
      var r;
      return (r = s.rightSide) == null ? void 0 : r.call(s);
    });
    return (r, c) => (f(), v("div", Ce({ class: "container-resizer flex flex-grow" }, r.$attrs), [
      t.enableLeftCollapse ? (f(), A(Oe, {
        key: 0,
        ref_key: "leftVCollapsibleRef",
        ref: i,
        "collapse-direction": "left"
      }, {
        default: W(() => [
          m("div", {
            ref_key: "leftSideSlot",
            ref: d,
            class: "flex"
          }, [
            C(r.$slots, "leftSide", {}, void 0, !0)
          ], 512)
        ]),
        _: 3
      }, 512)) : (f(), v("div", {
        key: 1,
        ref_key: "leftSideSlot",
        ref: d,
        class: "flex"
      }, [
        C(r.$slots, "leftSide", {}, void 0, !0)
      ], 512)),
      a.value ? (f(), v("div", {
        key: 2,
        class: "resizer -mr-1",
        onMousedown: c[0] || (c[0] = (V) => P(!0, V))
      }, null, 32)) : I("", !0),
      m("div", Vn, [
        C(r.$slots, "content", {}, void 0, !0)
      ]),
      o.value ? (f(), v("div", {
        key: 3,
        class: "resizer -ml-1",
        onMousedown: c[1] || (c[1] = (V) => P(!1, V))
      }, null, 32)) : I("", !0),
      t.enableRightCollapse ? (f(), A(Oe, {
        key: 4,
        ref_key: "rightVCollapsibleRef",
        ref: l,
        "collapse-direction": "right"
      }, {
        default: W(() => [
          m("div", {
            ref_key: "rightSideSlot",
            ref: n,
            class: "flex h-full"
          }, [
            C(r.$slots, "rightSide", {}, void 0, !0)
          ], 512)
        ]),
        _: 3
      }, 512)) : (f(), v("div", {
        key: 5,
        ref_key: "rightSideSlot",
        ref: n,
        class: "flex h-full"
      }, [
        C(r.$slots, "rightSide", {}, void 0, !0)
      ], 512))
    ], 16));
  }
});
const qn = /* @__PURE__ */ j(Pn, [["__scopeId", "data-v-3ec83934"]]);
export {
  qn as ContainerResizer,
  Un as FlyoutMenu,
  Fn as FormField,
  Rn as InlineEditable,
  zn as LoadingSpinner,
  Gn as ModalsConfirmation,
  De as VButton,
  In as VCheckbox,
  Oe as VCollapsible,
  An as VDropdown,
  Nn as VDropdownItem,
  Ct as VInput,
  Xt as VModal,
  jn as VModalHeader,
  On as VNotification,
  Dn as VRangeSlider,
  Ft as usePreventBodyScroll
};
